import { render, staticRenderFns } from "./AuthorizeCard.vue?vue&type=template&id=5479edda"
import script from "./AuthorizeCard.vue?vue&type=script&lang=js"
export * from "./AuthorizeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports